import type { MessageData, PaginatedResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { replaceParams, studentEndpoints } from "@/app/api/endpoints";
import type {
	AssignClassRequest,
	AssignClassResult,
	BulkApproveResult,
	BulkApproveStudentsRequest,
	CreateStudentRequest,
	ListStudentsParams,
	Student,
	UpdateStudentRequest,
} from "../types";

export const studentService = {
	async list(params: ListStudentsParams): Promise<PaginatedResponse<Student>> {
		const response = await apiClient.get<PaginatedResponse<Student>>(studentEndpoints.list, {
			params: {
				page: params.page,
				limit: params.limit,
				organizationId: params.organizationId,
				classGroupId: params.classGroupId,
				search: params.search,
				isActive: params.isActive,
				status: params.status,
				assignment: params.assignment,
			},
		});
		return response.data;
	},

	async getById(id: string): Promise<Student> {
		const url = replaceParams(studentEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<Student>>(url);
		return response.data.data;
	},

	async create(data: CreateStudentRequest): Promise<Student> {
		const response = await apiClient.post<SuccessResponse<Student>>(studentEndpoints.create, data);
		return response.data.data;
	},

	async update(id: string, data: UpdateStudentRequest): Promise<Student> {
		const url = replaceParams(studentEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<Student>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(studentEndpoints.delete, { id });
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},

	async approve(id: string): Promise<Student> {
		const url = replaceParams(studentEndpoints.approve, { id });
		const response = await apiClient.patch<SuccessResponse<Student>>(url);
		return response.data.data;
	},

	/** Ommaviy tasdiqlash (faqat tashkilot rahbari yoki super-admin) */
	async bulkApprove(data: BulkApproveStudentsRequest): Promise<BulkApproveResult> {
		const response = await apiClient.post<SuccessResponse<BulkApproveResult>>(
			studentEndpoints.bulkApprove,
			data
		);
		return response.data.data;
	},

	/** Sinfsiz o'quvchilarni sinfga biriktirish (faqat tashkilot rahbari) */
	async assignClass(data: AssignClassRequest): Promise<AssignClassResult> {
		const response = await apiClient.patch<SuccessResponse<AssignClassResult>>(
			studentEndpoints.assignClass,
			data
		);
		return response.data.data;
	},
};
